import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import modules from './modules/modules';
import events from './modules/events';
import calendar from './modules/calendar';
import users from './modules/users';
import roles from './modules/roles';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    modules,
    events,
    calendar,
    users,
    roles
  },
});